var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg150PieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.02,74.98C388.667,26.629,324.38,0,256,0c-0.269,0-0.537,0-0.806,0.001C255.13,0.001,255.065,0,255,0 c-0.125,0-0.25,0.002-0.374,0.004C186.759,0.358,123.009,26.953,74.98,74.98C26.629,123.333,0,187.62,0,256 s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512c46.812,0,92.616-12.757,132.462-36.893 c9.447-5.723,12.467-18.021,6.744-27.468c-5.724-9.449-18.021-12.467-27.469-6.745C334.143,461.244,295.504,472,256,472 c-119.103,0-216-96.897-216-216c0-112.019,85.714-204.395,195-214.987V256c0,11.046,8.954,20,20,20h216.064 c-3.33,35.495-15.499,69.683-35.69,99.885c-6.14,9.183-3.672,21.603,5.51,27.742c9.185,6.14,21.604,3.671,27.742-5.511 C497.002,355.674,512,306.531,512,256C512,187.62,485.371,123.333,437.02,74.98z M275,40.828 c15.156,1.327,29.868,4.226,43.972,8.532L275,93.327V40.828z M275,149.892l83.823-83.812c12.1,6.577,23.504,14.277,34.074,22.959 L275,206.936V149.892z M302.505,236l118.84-118.84c8.936,10.625,16.87,22.121,23.652,34.339L360.495,236H302.505z M417.064,236 l44.958-44.958c4.55,14.398,7.629,29.443,9.06,44.958H417.064z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg150PieChart);
export default __webpack_public_path__ + "static/media/150-pie-chart.53f0c9a5db66b2d8e289ac1c78692ca3.svg";
export { ForwardRef as ReactComponent };